// extracted by mini-css-extract-plugin
export default {"bannerComponent":"vk-z","red":"wk-z","calloutlink":"xk-z","headerTopBanner":"yk-z","bgcolorRed":"zk-z","headerTopCallout":"Ak-z","searchBanner":"Bk-z","hideMobile":"Ck-z"};